import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { setDeleteLoading } from "../../menu/menuSlice";
import {
  errorAlertHandle,
  successAlertHandle,
} from "../../../../utils/utilFunctions";

export const getFarmer = createAsyncThunk("app/getFarmer", async (id) => {
  const res = await axios.get(`/api/farmer?id=${id}`);
  return res.data;
});

export const getFarmers = createAsyncThunk(
  "app/getFarmers",
  async ({ start, limit, filters }) => {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({ ...filters });
    const res = await axios.post(
      `/api/farmer/filter?start=${start}&limit=${limit}`,
      body,
      config
    );
    return res.data;
  }
);

export const addFarmer = createAsyncThunk(
  "app/addFarmer",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const config = { headers: { "Content-Type": "application/json" } };
      const body = JSON.stringify(data);
      const res = await axios.post("api/farmer", body, config);
      successAlertHandle("Farmer added successfully!", dispatch);
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const updateFarmer = createAsyncThunk(
  "app/updateFarmer",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const config = { headers: { "Content-Type": "application/json" } };
      const body = JSON.stringify(data);
      const res = await axios.put("api/farmer", body, config);
      successAlertHandle("Farmer updated successfully!", dispatch);
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const deleteFarmer = createAsyncThunk(
  "app/deleteFarmer",
  async (id, { dispatch, rejectWithValue }) => {
    dispatch(setDeleteLoading(true));
    try {
      const res = await axios.delete(`/api/farmer?id=${id}`);
      successAlertHandle("Farmer deleted successfully!", dispatch);
      dispatch(setDeleteLoading(false));
      return res.data;
    } catch (err) {
      dispatch(setDeleteLoading(false));
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const getAllDocuments = async () => {
  try {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({});
    const res = await axios.post(`/api/document/filter`, body, config);
    return res.data;
  } catch (error) {
    console.log(error.message);
  }
};

export const getProducts = async () => {
  try {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({});
    const res = await axios.post(`/api/product/filter`, body, config);
    return res.data;
  } catch (error) {
    console.log(error.message);
  }
};

export const addDocument = async ({ type, name }) => {
  try {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({ type, name });
    const res = await axios.post(`/api/document`, body, config);
    return res.data;
  } catch (error) {
    console.log(error.message);
  }
};

export const getDocImage = async (id, name) => {
  try {
    const res = await axios.get(
      `/api/image?profile=farmer&id=${id}&name=${name}`
    );
    return res.data;
  } catch (err) {
    throw new Error(err);
  }
};

export const exportFarmer = async ({ filters }) => {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const body = JSON.stringify({ ...filters });
    const res = await axios.post(`/api/farmer/download`, body, config);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const farmerFilter = createAsyncThunk(
  "app/farmerFilter",
  async ({ filters, setter }, { dispatch, rejectWithValue }) => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const body = JSON.stringify({ ...filters });
      const res = await axios.post(`/api/farmer/finite-filter`, body, config);
      setter(true);
      return res;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);
